import React from 'react'
import { Col, Form } from 'antd'
import { useTranslation } from 'lib/i18n'

import InputWithoutAutoComplete from 'components/InputWithoutAutoComplete/InputWithoutAutoComplete'
import {
  VIDEO_REQUEST_IS_GIFT,
  VIDEO_REQUEST_TO_NAME,
} from 'components/ProductPage/shared/FieldConstants'

function ToField({ label, ...rest }) {
  const { t } = useTranslation()

  return (
    <Form.Item
      name={VIDEO_REQUEST_TO_NAME}
      label={label}
      rules={[
        {
          required: true,
          message: t(
            'VideoRequestForm.toRequired',
            'Fill in the recipients name',
          ),
        },
      ]}
      data-cy="toName"
    >
      <InputWithoutAutoComplete size="large" {...rest} />
    </Form.Item>
  )
}

export default function ToName({ placeholder = '', label }) {
  const { t } = useTranslation()

  return (
    <Form.Item shouldUpdate>
      {({ getFieldValue }) => (
        <Col>
          {getFieldValue(VIDEO_REQUEST_IS_GIFT) ? (
            <ToField
              label={label ?? t('VideoRequestForm.toLabel', 'To')}
              placeholder={placeholder}
            />
          ) : (
            <ToField
              label={label ?? t('VideoRequestForm.toLabelNonGift', 'Your name')}
              placeholder={placeholder}
            />
          )}
        </Col>
      )}
    </Form.Item>
  )
}
